export default {"src":"/_next/static/media/ic-discord.237ec211.svg","height":32,"width":31};